import { pluck } from '../../../store.decorator';
import { createReducer } from '../../../store.model';

import {
    ActionType,
    FilterRanks,
    FilterScorecardPublishStatus,
    FilterSuperGroups,
    Navigate,
    ScorecardTrendSelectionChange,
    SelectView,
    SetTrendChartData,
    SetTrendChartFilters,
} from './scorecard-trend-chart.action';
import {
    createEmptyTrendChartData,
    StcVerticalBarLineDataBar,
} from './scorecard-trend-chart.model';
import {
    ScorecardPublishedStatusFilterTransformer as PublishedStatusFilterTransformer,
    RanksFilterTransformer,
    SuperGroupsFilterTransformer,
    VerticalBarLineDataTransformer,
} from './scorecard-trend-chart.operators';
import {
    createEmptyTrendChartDataFilters,
    createInitialTrendChart,
    defaultScorecardTrendChartState,
    NUM_BARS_WIDE,
    ScorecardTrendChartState,
} from './scorecard-trend-chart.state';

const { reducer, builder } = createReducer<
    ActionType,
    ScorecardTrendChartState
>(defaultScorecardTrendChartState());

builder
    .add<FilterRanks>(
        ActionType.SCORECARD_TREND__FILTER_RANKS,
        (state, action) => {
            let trendChart = state.selectedTrendChart;
            let trendChartFilters = trendChart.trendChartFiltersAndData.get(
                trendChart.periodType,
            );

            const nextScRkFilter = [...action.payload.ranks];
            trendChartFilters = {
                ...trendChartFilters,
                ranksFilter: nextScRkFilter,
            };

            trendChart = {
                ...trendChart,
                ranksFilter: nextScRkFilter,
            };

            const nextScTrChtDtVerBarLnData =
                new VerticalBarLineDataTransformer(
                    action.payload.scorecardHistory,
                    action.payload.selectedScorecardId,
                ).transform(trendChart);

            trendChartFilters = {
                ...trendChartFilters,
                scorecardTrendChartData: {
                    ...trendChartFilters.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trendChartFilters.periodType,
                trendChartFilters,
            );

            trendChart = {
                ...trendChart,
                scorecardTrendChartData: {
                    ...trendChart.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };

            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    )
    .add<FilterScorecardPublishStatus>(
        ActionType.SCORECARD_TREND__FILTER_SCORECARD_PUBLISH_STATUS,
        (state, action) => {
            let trendChart = state.selectedTrendChart;
            let trendChartFilters = trendChart.trendChartFiltersAndData.get(
                trendChart.periodType,
            );

            const nextScPbStFilter = [
                ...action.payload.scorecardPublishStatuses,
            ];
            trendChartFilters = {
                ...trendChartFilters,
                publishStatusFilter: nextScPbStFilter,
            };

            trendChart = {
                ...trendChart,
                publishStatusFilter: nextScPbStFilter,
            };
            const nextScTrChtDtVerBarLnData =
                new VerticalBarLineDataTransformer(
                    action.payload.scorecardHistory,
                    action.payload.selectedScorecardId,
                ).transform(trendChart);

            trendChartFilters = {
                ...trendChartFilters,
                scorecardTrendChartData: {
                    ...trendChartFilters.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trendChartFilters.periodType,
                trendChartFilters,
            );

            trendChart = {
                ...trendChart,
                scorecardTrendChartData: {
                    ...trendChart.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };

            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    )
    .add<FilterSuperGroups>(
        ActionType.SCORECARD_TREND__FILTER_SUPERGROUPS,
        (state, action) => {
            let trendChart = state.selectedTrendChart;
            let trendChartFilters = trendChart.trendChartFiltersAndData.get(
                trendChart.periodType,
            );

            const nextScSgFilter = [...action.payload.superGroups];
            trendChartFilters = {
                ...trendChartFilters,
                supergroupsFilter: nextScSgFilter,
            };

            trendChart = {
                ...trendChart,
                supergroupsFilter: nextScSgFilter,
            };
            const nextScTrChtDtVerBarLnData =
                new VerticalBarLineDataTransformer(
                    action.payload.scorecardHistory,
                    action.payload.selectedScorecardId,
                ).transform(trendChart);

            trendChartFilters = {
                ...trendChartFilters,
                scorecardTrendChartData: {
                    ...trendChartFilters.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trendChartFilters.periodType,
                trendChartFilters,
            );

            trendChart = {
                ...trendChart,
                scorecardTrendChartData: {
                    ...trendChart.scorecardTrendChartData,
                    verticalBarLineData: nextScTrChtDtVerBarLnData,
                },
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };

            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    );

builder
    .add<SetTrendChartFilters>(
        ActionType.SCORECARD_TREND__SET_FILTERS,
        (state, action) => {
            let trendChart =
                state.trendCharts.get(action.payload.tabId) ||
                createInitialTrendChart(
                    action.payload.periodType,
                    action.payload.tabId,
                );
            let trChtFilters =
                trendChart.trendChartFiltersAndData.get(
                    action.payload.periodType,
                ) ||
                createEmptyTrendChartDataFilters(action.payload.periodType);

            const buttonHit = action.payload.reset;
            const sgColourPool = action.payload.superGroupColourPool;
            const nextScRkFtr =
                (!buttonHit && trChtFilters.ranksFilter) ||
                new RanksFilterTransformer(
                    action.payload.rankColourPool,
                ).transform(action.payload.scorecardHistory);
            const nextScSgFtr =
                (!buttonHit && trChtFilters.supergroupsFilter) ||
                new SuperGroupsFilterTransformer(sgColourPool).transform(
                    action.payload.scorecardHistory,
                );
            const nextScPubStFtr =
                (!buttonHit && trChtFilters.publishStatusFilter) ||
                new PublishedStatusFilterTransformer().transform(
                    action.payload.scorecardHistory,
                );

            trChtFilters = {
                ...trChtFilters,
                ranksFilter: nextScRkFtr,
                supergroupsFilter: nextScSgFtr,
                publishStatusFilter: nextScPubStFtr,
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trChtFilters.periodType,
                trChtFilters,
            );

            trendChart = {
                ...trendChart,
                periodType: trChtFilters.periodType,
                ranksFilter: nextScRkFtr,
                supergroupsFilter: nextScSgFtr,
                publishStatusFilter: nextScPubStFtr,
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };

            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    )
    .add<SetTrendChartData>(
        ActionType.SCORECARD_TREND__SET_CHART_DATA,
        (state, action) => {
            let trendChart = state.trendCharts.get(action.payload.tabId);
            let trendChartData = trendChart.trendChartFiltersAndData.get(
                action.payload.periodType,
            );

            let nextScTrChtData =
                trendChartData.scorecardTrendChartData ||
                createEmptyTrendChartData();
            const nextScTrChtDtVerBarLnData =
                new VerticalBarLineDataTransformer(
                    action.payload.scorecardHistory,
                    action.payload.selectedScorecardId,
                ).transform(trendChart);

            const totalColumns = pluck<StcVerticalBarLineDataBar[]>(
                nextScTrChtDtVerBarLnData,
                'bars.values[]',
            ).length;

            nextScTrChtData = {
                ...nextScTrChtData,
                verticalBarLineData: nextScTrChtDtVerBarLnData,
                showTrendViewOptions: totalColumns > NUM_BARS_WIDE,
            };

            trendChartData = {
                ...trendChartData,
                scorecardTrendChartData: nextScTrChtData,
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trendChartData.periodType,
                trendChartData,
            );

            trendChart = {
                ...trendChart,
                periodType: trendChartData.periodType,
                scorecardTrendChartData: nextScTrChtData,
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };

            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    )
    .add<ScorecardTrendSelectionChange>(
        ActionType.SCORECARD_TREND__CHART_SELECTION_CHANGE,
        (state, action) => {
            let trendChart = state.selectedTrendChart;
            let trendChartData = trendChart.trendChartFiltersAndData.get(
                trendChart.periodType,
            );

            const currentBarsVerticalBarLineData =
                trendChart.scorecardTrendChartData.verticalBarLineData.bars;

            const currentSelectedBarGroup = currentBarsVerticalBarLineData.find(
                (x) => x.values.some((y) => y.isSelected),
            );
            if (currentSelectedBarGroup) {
                const currentSelectedBar = currentSelectedBarGroup.values.find(
                    (x) => x.isSelected,
                );
                const currentScTrChrSdBrData: StcVerticalBarLineDataBar = {
                    ...currentSelectedBar,
                    isSelected: false,
                };
                currentSelectedBarGroup.values.splice(
                    currentSelectedBarGroup.values.indexOf(currentSelectedBar),
                    1,
                    currentScTrChrSdBrData,
                );
            }

            const nextSelectedBarGroup = currentBarsVerticalBarLineData.find(
                (x) =>
                    x.values.some(
                        (y) =>
                            y.value.scorecardId ===
                            action.payload.selectedScorecard.value.scorecardId,
                    ),
            );
            const nextSelectedBar = nextSelectedBarGroup.values.find(
                (x) =>
                    x.value.scorecardId ===
                    action.payload.selectedScorecard.value.scorecardId,
            );
            const nextScTrChrSdBrData: StcVerticalBarLineDataBar = {
                ...action.payload.selectedScorecard,
                isSelected: true,
            };
            nextSelectedBarGroup.values.splice(
                nextSelectedBarGroup.values.indexOf(nextSelectedBar),
                1,
                nextScTrChrSdBrData,
            );

            trendChartData = {
                ...trendChartData,
                scorecardTrendChartData: {
                    ...trendChartData.scorecardTrendChartData,
                    verticalBarLineData: {
                        ...trendChartData.scorecardTrendChartData
                            .verticalBarLineData,
                        bars: currentBarsVerticalBarLineData,
                    },
                },
            };

            const nextTrendChartDataFilters = new Map(
                trendChart.trendChartFiltersAndData,
            );
            nextTrendChartDataFilters.set(
                trendChartData.periodType,
                trendChartData,
            );

            trendChart = {
                ...trendChart,
                scorecardTrendChartData: {
                    ...trendChart.scorecardTrendChartData,
                    verticalBarLineData: {
                        ...trendChart.scorecardTrendChartData
                            .verticalBarLineData,
                        bars: currentBarsVerticalBarLineData,
                    },
                },
                trendChartFiltersAndData: nextTrendChartDataFilters,
            };
            const nextTrendCharts = new Map(state.trendCharts);
            nextTrendCharts.set(trendChart.tabId, trendChart);
            return {
                ...state,
                selectedTrendChart: trendChart,
                trendCharts: nextTrendCharts,
            };
        },
    );

builder.add<SelectView>(
    ActionType.SCORECARD_TREND__SELECT_VIEW,
    (state, action) => {
        return {
            ...state,
            selectedView: action.payload.view,
        };
    },
);

builder.add<Navigate>(ActionType.SCORECARD_TREND__NAVIGATE, (state, action) => {
    return {
        ...state,
        navigation: {
            numPages: action.payload.numPages,
        },
    };
});

export default {
    trendChart: reducer,
};
